export enum ShowingRequestStatus {
  FORMING = 'Forming',
  PENDING = 'Pending',
  ACCEPTED = 'Accepted',
  DECLINED = 'Declined',
  CANCELED_BY_RENTER = 'Cancelled by Renter',
  CANCELED_BY_INVESTOR = 'Canceled by Investor',
  RESCHEDULED = 'Rescheduled',
  EXPIRED = 'Expired',
}
